var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M4.078-5.766A.421.421,0,0,1,4.5-6.187a.421.421,0,0,1,.422.422V-3.6l1.5,1a.407.407,0,0,1,.1.585.387.387,0,0,1-.57.1L4.266-3.039a.385.385,0,0,1-.188-.352ZM4.5-7.875A4.5,4.5,0,0,1,9-3.375a4.5,4.5,0,0,1-4.5,4.5A4.5,4.5,0,0,1,0-3.375,4.5,4.5,0,0,1,4.5-7.875ZM.844-3.375A3.656,3.656,0,0,0,4.5.281,3.656,3.656,0,0,0,8.156-3.375,3.656,3.656,0,0,0,4.5-7.031,3.656,3.656,0,0,0,.844-3.375Z",
    transform: "translate(0 7.875)",
    fill: "#262532",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeWaiting);
export default __webpack_public_path__ + "static/media/badge-waiting.c91e8e933e399ef7ce6c98b03bf84916.svg";
export { ForwardRef as ReactComponent };